import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-edit-program',
  templateUrl: './edit-program.component.html'
})
export class EditProgramComponent implements OnInit, AfterViewInit {

  programForm: FormGroup | any;
  file: any;
  imageType: any;
  imageUrl: any;
  countryArr: any = [];
  programList: any;
  viewId: any;
  IsFree: string = "";
  programTypeList: any;
  public description: any;

  constructor(public service: MainService, private router: Router,
    private activatedroute: ActivatedRoute) {
    this.activatedroute.params.subscribe((res) => {
      this.viewId = res.id;
    })
  }

  ngOnInit() {
    this.programFormValidation();
    this.viewProgramList();
    this.viewProgramTypeList();
  }
  ngAfterViewInit() {
    this.viewProgramList()
  }

  // Add Subadmin Form Validation

  programFormValidation() {
    this.programForm = new FormGroup({
      'title': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(256), Validators.pattern(/^[^\s][a-zA-Z ]*$/)])),
      'programType': new FormControl('', Validators.compose([Validators.required])),
      'therapistSession': new FormControl(''),
      'MedicalSession': new FormControl(''),
      'CaseManager': new FormControl(''),
      'description': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(1000)])),
      'amount': new FormControl('', Validators.compose([Validators.required])),
      'isInsurancePackage': new FormControl('No')
    })
  }

  programTypeChange(value: string) {
    if (value === 'FREE') {
      this.IsFree = 'readonly';
      this.programForm.patchValue({
        programType: 'FREE',
        amount: '0'
      });
    }
    else {
      this.IsFree = ''
    }
  }


  // program list api inntegration 
  viewProgramList() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.viewProgram + `?programId=${this.viewId}`, 1).subscribe((res) => {

      if (res.responseCode == 200) {
        this.programList = res.result;
        //  this.description =  this.programList.description;
        setTimeout(() => {
          this.programForm.patchValue({
            description: this.programList.description
          })
          // this.programForm =  this.programList.description;
          this.service.hideSpinner();
        }, 1000);

        this.programForm.patchValue({
          title: this.programList.title,
          amount: this.programList.amount,
          programType: this.programList.programType,
          therapistSession: this.programList.therapist_session,
          MedicalSession: this.programList.physician_session,
          CaseManager: this.programList.caseManager_session,
          description: this.programList.description,
          isInsurancePackage: this.programList.is_insurance_package ? "Yes" : "No"
        });

      }
      else {
        this.service.hideSpinner();
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }

  // view ProgramType List api inntegration 
  viewProgramTypeList() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.programType_list, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.programTypeList = res.result;
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }


  // edit program api integration

  editProgram() {
    // var regex = /(<([^>]+)>)/ig; 
    // let desc =  this.description.replace(regex, "");
    const data = {
      title: this.programForm.value.title,
      programId: this.viewId,
      amount: this.programForm.value.amount,
      programType: this.programForm.value.programType,
      therapist_session: this.programForm.value.therapistSession || 0,
      physician_session: this.programForm.value.MedicalSession || 0,
      caseManager_session: this.programForm.value.CaseManager || 0,
      description: this.programForm.value.description,
      is_insurance_package: this.programForm.value.isInsurancePackage == 'Yes'
    }
    this.service.showSpinner();
    this.service.putApi(`${ApiUrls.editProgram}?programId=${this.viewId}`, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.service.successToast(res.responseMessage);
        this.router.navigateByUrl('/program-mgt');
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, (err) => {
      this.service.errorToast(err.responseMessage)
      this.service.hideSpinner();
    })

  }


  // Block special character from name
  inputkeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
    }
  }
  //Allow only numbers
  inputKeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 47 && k < 58) || k == 8);
    }
  }

  //For password keypres
  passwordKeyPress(e: any) {
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
  }

  getCountryCodeData() {
    this.service.getCountryCode().subscribe((res) => {
      this.countryArr = res
    })
  }



}
